var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"ml-2",attrs:{"size":"large","loading":_vm.loading},on:{"click":_vm.exportUsers}},[_c('fa',{staticClass:"mr-2",attrs:{"icon":"file-download"}}),_vm._v(" "+_vm._s(_vm.$t("EXPORT"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }